
/* global TimelineLite Waypoint */

/* eslint-disable */

(function () {

	"use strict";

	var animationStarted = false;
	var t = new TimelineLite();
	var ease = window.Power4.easeInOut;
	var edrDiagram = document.querySelector(".edr-diagram") || null;
	var mvedrDiagram = document.querySelector(".multi-vector-edr-diagram") || null;
	var event;

	function timeLineLiteComplete() {
		// trigger custom event to when hero image completes animating
		if (window.CustomEvent) {
			event = new CustomEvent("timeLineLiteCompleteEvent");
		} else {
			event = document.createEvent("CustomEvent");
			event.initCustomEvent("timeLineLiteCompleteEvent", true, true);
		}

		edrDiagram.dispatchEvent(event);
	}

	new Waypoint({
		element: document.getElementById("edr-diagram"),
		offset: "75%",
		handler: function (direction) {
			if (direction === "down" && !animationStarted) {
				animationStarted = true;
				t.fromTo(
					edrDiagram,
					1,
					{
						x: "25%",
						autoAlpha: 0
					},
					{
						x: "0%",
						autoAlpha: 1,
						ease: ease
					}
				);
				t.to(
					edrDiagram,
					1,
					{
						//transform: "rotate(180deg)",
						rotation: "+=180",
						transformOrigin: "center center",
						// autoAlpha: 1,
						// ease: ease,
						onComplete: timeLineLiteComplete
					}
				);
				t.to(
					edrDiagram,
					1,
					{
						autoAlpha: 0
					}
				);
				t.to(
					mvedrDiagram,
					1,
					{
						autoAlpha: 1
					},
					"-=1"
				);
			}
		}
	});

}());
